<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"COMMON.ADD" | translate}} Unavailability</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content shift-container">
        <form action="" [formGroup]="addForm">

            <div class="mt-3 me-4">
                <mat-slide-toggle color="primary" class="mb-0 slide-1" (change)="onToggleChange($event)"
                    formControlName="unavailableAllDay"></mat-slide-toggle>
                <label for="" class="mb-0">Unavailable all day</label>
            </div>

            <div class="mt-3 me-4">
                <label for=""> Select Date</label>
                <div class="in-box">
                    <input class="form-control w-auto" [matDatepicker]="eDate" placeholder="Select Date"
                        formControlName="st_dt" />
                    <mat-datepicker-toggle matIconSuffix [for]="eDate"></mat-datepicker-toggle>
                    <mat-datepicker #eDate></mat-datepicker>
                </div>
            </div>
            <div formArrayName="dateRanges" *ngIf="!isToggleOn">
                <div *ngFor="let range of dateRanges.controls; let i = index" [formGroupName]="i"
                    class="mt-3 me-4 d-flex align-items-center gap-2">
                  
                    <label class="mb-0" for="">From</label>
                    <div class="in-box">
                        <input class="form-control ps-3 w-auto time-input" formControlName="st_ti"
                            [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" placeholder="00:00">
                        <owl-date-time [pickerType]="'timer'" #dt1  [hour12Timer]="false" ></owl-date-time>
                    </div>

                    <label class="mb-0" for="">To</label>
                    <div class="in-box">
                        <input class="form-control ps-3 w-auto time-input" formControlName="ed_ti"
                            [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" placeholder="00:00">
                        <owl-date-time [pickerType]="'timer'" #dt2  [hour12Timer]="false"  ></owl-date-time>
                    </div>
                    
                    <button type="button" class="btn btn-danger ms-2" (click)="removeDateRange(i)">Remove</button>
                </div>
            </div>

            <div class="i-box cursor-pointer mt-3" *ngIf="!isToggleOn"> 
                <span (click)="addDateRange()"><i class="fas fa-plus"></i> Add New Dates</span>
            </div>

            <div class="mt-3 me-4">
                <label for=""> Select Employee</label>
                <div class="mt-1">
                    <ng-select [items]="filterEmployeeArr" bindLabel="first_name" [searchFn]="customSearchFn"
                        bindValue="em_i" [multiple]="true" placeholder="Select Employee" [editableSearchTerm]="true"
                        [closeOnSelect]="false" groupBy="e" [selectableGroup]="true" [selectableGroupAsModel]="false"
                        formControlName="employee_ids">
                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{standalone: true}" />
                            Select All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="d-flex align-items-center em-box">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                    [ngModelOptions]="{standalone: true}" class="me-2" />
                                <i class="material-icons me-2 star" *ngIf="(item.is_f==1)">star_rate</i>
                                <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                                <div> {{ item.first_name }} {{ item.last_name }}</div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="mt-3 me-4">
                <label for="">Note:</label>
                <textarea class="form-control " formControlName="note"></textarea>
            </div>
            <div>
                <mat-checkbox name="repeat" formControlName="repeat">
                    <div class="text-wrap">Repeat</div>
                </mat-checkbox>
                <div class="i-box cursor-pointer mt-3" *ngIf="addForm.get('repeat')?.value==true">
                    <span (click)="addRoster()">Add Repeat Settings</span>
                </div>
            </div>
        </form>
    </div>
    <div class="item-footer">
        <div class="row">
            <div class="col-md-6 m-auto">
                <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                    (click)="onSubmit()">
                    {{ "BUTTON.SAVE" | translate }} </button>
            </div>
        </div>
    </div>
</div>